<template>
    <CRow>
        <CCol>
            <CCard class="mb-4">
                <CCardHeader>
                    <strong>Стол заказов</strong>
                    <ShopCatalogTabLinks class="mt-2" />
                </CCardHeader>
                <CCardBody>
                    <p class="text-muted">
                        Дополнительно к субботе и воскресенью можно указать праздничные
                        и другие нерабочие дни — в эти даты заказы не принимаются.
                    </p>

                    <div class="form-inline mb-4">
                        <input
                            v-model="newDay"
                            type="date"
                            class="form-control mr-2"
                        >
                        <input
                            v-model="newTitle"
                            class="form-control mr-2"
                            placeholder="Комментарий (необязательно)"
                            @keyup.enter="addHoliday"
                        >
                        <CButton
                            color="primary"
                            :disabled="saving || !newDay"
                            @click="addHoliday"
                        >
                            Добавить
                        </CButton>
                    </div>

                    <div
                        v-if="loading"
                        class="text-muted"
                    >
                        Загрузка…
                    </div>
                    <div
                        v-else-if="!holidays.length"
                        class="text-muted"
                    >
                        Список выходных дней пуст.
                    </div>
                    <div
                        v-for="holiday in holidays"
                        :key="holiday.id"
                        class="form-inline mb-2"
                    >
                        <span class="mr-3 font-weight-bold">{{ formatDay(holiday.day) }}</span>
                        <span class="mr-3 text-muted">{{ holiday.title || '—' }}</span>
                        <CButton
                            color="danger"
                            variant="outline"
                            size="sm"
                            :disabled="removingId === holiday.id"
                            @click="removeHoliday(holiday.id)"
                        >
                            Удалить
                        </CButton>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from 'vue';
import ShopCatalogTabLinks from '@/components/ShopCatalogTabLinks';

export default {
    name: 'ShopHolidaysSettings',

    components: {
        ShopCatalogTabLinks
    },

    data() {
        return {
            loading: false,
            saving: false,
            removingId: null,
            holidays: [],
            newDay: '',
            newTitle: ''
        };
    },

    mounted() {
        this.loadHolidays();
    },

    methods: {
        formatDay(day) {
            if (!day) return '';
            const [y, m, d] = String(day).split('-');
            if (!y || !m || !d) return day;
            return `${d}.${m}.${y}`;
        },

        loadHolidays() {
            this.loading = true;
            return Vue.axios.get('/shop-catalog/holidays')
                .then(({ data }) => {
                    this.holidays = data || [];
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить выходные дни');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        addHoliday() {
            if (!this.newDay || this.saving) return;
            this.saving = true;
            Vue.axios.post('/shop-catalog/holidays', {
                day: this.newDay,
                title: this.newTitle
            })
                .then(() => {
                    this.newDay = '';
                    this.newTitle = '';
                    return this.loadHolidays();
                })
                .catch(error => {
                    const message = error?.response?.data?.error || 'Не удалось добавить дату';
                    this.$root.$emit('showError', message);
                })
                .finally(() => {
                    this.saving = false;
                });
        },

        removeHoliday(id) {
            if (!id || this.removingId) return;
            this.removingId = id;
            Vue.axios.delete(`/shop-catalog/holidays/${id}`)
                .then(() => this.loadHolidays())
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось удалить дату');
                })
                .finally(() => {
                    this.removingId = null;
                });
        }
    }
};
</script>
